import * as actionTypes from '../actionTypes'
import en from '../translations/lang/en-US'
import pseudo from '../translations/lang/en-pseudo'
import fr from '../translations/lang/fr'
import { defaultLocale } from '../reducers/i18n'

export const loadLocale = (locale) => {
	return async (dispatch, getState) => {
		dispatch(loadingStarted())
		locale = locale || defaultLocale
		switch(locale) {
			case 'en-pseudo':
				dispatch(loadingCompleted(locale, Object.assign({}, en, pseudo)))
				break
			case 'fr':
				dispatch(loadingCompleted(locale, Object.assign({}, en, fr)))
				break
			default:
				dispatch(loadingCompleted(locale, en))
		}
	}
}

export const loadingStarted = () => ({
	type: actionTypes.I18N_LOADING_STARTED
})

export const loadingCompleted = (locale, messages) => ({
	type: actionTypes.I18N_LOADING_COMPLETED,
	messages: messages,
	locale: locale
})


// WEBPACK FOOTER //
// ./src/actions/i18n.js